var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import RecentActivity from '~/api/recent_activity';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
const RecentActivityContext = createContext({});
const RecentActivityTabs = {
    DOCUMENTS: 'documents',
    DOCUMENT_COMPARISON: 'document-comparison',
};
const RecentActivityProvider = (props) => {
    const { tab: activeTab } = useParams();
    const { hasPermission } = useUser();
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [isLoadingComparisons, setIsLoading] = useState(false);
    const [comparisons, setComparisons] = useState(null);
    const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);
    const [documents, setDocuments] = useState(null);
    const getComparisonDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        setComparisons(null);
        setDocuments(null);
        setIsLoading(true);
        const recentComparisonActivity = yield RecentActivity.getDocumentComparisons();
        if (!(recentComparisonActivity === null || recentComparisonActivity === void 0 ? void 0 : recentComparisonActivity.length)) {
            setIsLoading(false);
            setComparisons([]);
            return;
        }
        setComparisons(recentComparisonActivity);
        setIsLoading(false);
    });
    const getDocuments = () => __awaiter(void 0, void 0, void 0, function* () {
        setDocuments(null);
        setComparisons(null);
        setIsLoadingDocuments(true);
        const documents = yield RecentActivity.getDocuments();
        if (!(documents === null || documents === void 0 ? void 0 : documents.length)) {
            setIsLoadingDocuments(false);
            setDocuments([]);
            return;
        }
        setDocuments(documents);
        setIsLoadingDocuments(false);
    });
    useEffect(() => {
        const hasMultipleTabs = hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENTS) &&
            hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS);
        if (hasMultipleTabs) {
            if (activeTab === undefined) {
                getDocuments();
            }
        }
        else {
            if (hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS)) {
                getComparisonDetails();
            }
            if (hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENTS)) {
                getDocuments();
            }
        }
    }, []);
    useEffect(() => {
        if (activeTab === RecentActivityTabs.DOCUMENTS) {
            getDocuments();
        }
        if (activeTab === RecentActivityTabs.DOCUMENT_COMPARISON) {
            getComparisonDetails();
        }
    }, [activeTab]);
    const value = {
        isLoadingComparisons,
        isLoadingDocuments,
        comparisons,
        setComparisons,
        documents,
        setDocuments,
        selectedDocument,
        setSelectedDocument,
    };
    return React.createElement(RecentActivityContext.Provider, Object.assign({ value: value }, props));
};
const useRecentActivity = () => {
    const context = useContext(RecentActivityContext);
    if (!context) {
        throw new Error('RecentActivityContext must be used inside of a RecentActivityProvider');
    }
    return context;
};
export { RecentActivityProvider, useRecentActivity, };
